<template>
  <div>
    <div class="d-flex mb-2">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          NO：{{ formData.amzSampleNo ? formData.amzSampleNo : '新增' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          class="mr-2"
          style="font-size: 12px"
          :variant="
            formData.amzSampleStatus === 'Y'
              ? 'success'
              : formData.amzSampleStatus === 'D'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_amzSampleStatus || '草稿' }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Modify：{{ formData.modifyByName ? formData.modifyByName : '--' }} at
          {{ formData.modifyDate ? formData.modifyDate : '--' }}
        </span>
      </div>
    </div>
    <el-form ref="form" :model="formData" :rules="rules" size="mini">
      <el-row :gutter="10">
        <div @click="onImagePreview" class="mr-3">
          <el-image
            style="width: 130px; height: 130px;"
            fit="cover"
            :src="formData.defaultImageUrl"
          >
            <div slot="error" class="image-slot">
              <img
                src="/image/static/img/nopic-square.jpg"
                style="width: 130px; height: 130px;"
              />
            </div>
          </el-image>
        </div>
        <el-col :span="22">
          <el-row :gutter="10">
            <el-col :span="4">
              <el-form-item
                :label="$l('form_label_amz_sample_type') || '样品类型'"
                prop="amzSampleType"
              >
                <dict-select
                  v-model="formData.amzSampleType"
                  :body="{ dictType: 'amzSampleType' }"
                  url="/sys/common/dict/system"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                  filterable
                  clearable
                  :disabled="formDisabled"
                  size="mini"
                  style="width:100%"
                  @change="changeIsMany()"
                />
              </el-form-item>
            </el-col>

            <el-col :span="4">
              <el-form-item
                :label="$l('INDEX.order_form_label_brand') || '品牌'"
                prop="brandCode"
              >
                <dict-select
                  v-model="formData.brandCode"
                  url="/master/common/dict/spuBrandSelect"
                  :placeholder="
                    $l('INDEX.form_label_please_select_brand') || '请选择品牌'
                  "
                  :selectedLabel.sync="formData.brandName"
                  clearable
                  filterable
                  size="mini"
                  style="width:100%"
                  :disabled="formDisabled"
                  @change="clearSpu()"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                :label="$l('INDEX.table_label_succession') || '系列'"
                prop="collectionNo"
              >
                <dict-select
                  v-model="formData.collectionNo"
                  url="/master/common/dict/multilingual"
                  :placeholder="
                    $l('INDEX.form_label_selectseries') || '请选择系列'
                  "
                  :body="{ dictType: 'skuCollection' }"
                  :options="{ label: 'labelEn', value: 'value' }"
                  :selectedLabel.sync="formData.collectionName"
                  clearable
                  filterable
                  size="mini"
                  style="width:100%"
                  :disabled="formDisabled"
                  @change="clearSpu()"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_spu_info') || 'SPU信息'"
                prop="spuInfo"
              >
                <el-input
                  v-model="formData.spuInfo"
                  readonly
                  :disabled="formDisabled"
                  :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-finished"
                    @click="openChooseSpu"
                    :disabled="formDisabled"
                  ></el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item
                :label="$l('INDEX.form_label_color') || '颜色'"
                prop="colorCode"
              >
                <el-select
                  v-model="formData.colorCode"
                  collapse-tags
                  size="mini"
                  style="width:100%"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                  clearable
                  filterable
                  @change="colorChange"
                  :disabled="formDisabled"
                >
                  <el-option
                    v-for="item in colorOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    class="brand-select"
                  >
                    <span style="float: left">{{ item.colorName }}</span>
                    <span
                      v-if="item.colorCard"
                      class="colorCard"
                      :style="{ background: item.colorCard }"
                    >
                    </span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_goods_pattern') || '花型'"
                prop="goodsPattern"
              >
                <el-select
                  v-model="formData.goodsPattern"
                  collapse-tags
                  size="mini"
                  style="width:100%"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                  clearable
                  filterable
                  :disabled="formDisabled"
                  @change="changeIsMany()"
                >
                  <el-option
                    v-for="item in goodsPatternOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    class="brand-select"
                  >
                    <span>{{ item.value }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_color_pantone') || '潘通色号'"
                prop="colorPantone"
              >
                <dict-select
                  v-model="formData.colorPantone"
                  :body="{ dictType: 'colorPantone' }"
                  url="/master/common/dict/biz"
                  :options="{ label: 'label', value: 'this' }"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                  multiple
                  filterable
                  clearable
                  size="mini"
                  style="width:100%"
                  :disabled="formDisabled"
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-form-item :label="''" class="mr-3">
          <br />
          <el-button
            plain
            type="primary"
            style="width:130px"
            @click="visible = true"
            :disabled="imageDisabled && imageVisible"
            >{{ $l('form_label_picture_maintenance') || '图片维护' }}</el-button
          >
        </el-form-item>
        <el-col :span="22">
          <el-row :gutter="10" type="flex" justify="end">
            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_sample_date') || '样品日期'"
                prop="sampleDate"
              >
                <el-date-picker
                  v-model="formData.sampleDate"
                  :disabled="formDisabled"
                  :picker-options="pickerOptions"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_label_date') || '标签生成日期'"
              >
                <el-date-picker
                  v-model="formData.labelDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  disabled
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_scm_sample_no') || '工厂样品编号'"
                prop="scmSampleNo"
              >
                <el-input
                  v-model="formData.scmSampleNo"
                  maxlength="50"
                  show-word-limit
                  clearable
                  :disabled="formDisabled"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_scm') || '工厂'"
                prop="scmCode"
              >
                <dict-select
                  v-model="formData.scmCode"
                  url="/master/common/dict/scmPartners"
                  :placeholder="$l('form_placeholder_scm') || '请选择工厂'"
                  :selectedLabel.sync="formData.scmName"
                  filterable
                  clearable
                  size="mini"
                  style="width:100%"
                  :disabled="formDisabled"
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-form-item :label="' '" class="mr-3">
          <div style="width:130px"></div>
        </el-form-item>
        <el-col :span="22">
          <el-form-item :label="'备注'" prop="remark">
            <el-input
              v-model="formData.remark"
              :disabled="formDisabled"
              maxlength="300"
              show-word-limit
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="mt-2">
        <el-col :span="24">
          <SkuTable
            :disabled="formDisabled"
            :extraData="extraData"
            :isMany="isMany"
            ref="skuTable"
          />
        </el-col>
      </el-row>

      <div class="d-flex justify-content-end mb-2 mt-3">
        <el-button
          type="primary"
          size="mini"
          v-if="!formDisabled"
          @click="save()"
          style="width: 80px"
          >{{ $l('INDEX.btn_save') || '保存' }}</el-button
        >
      </div>
    </el-form>
    <SampleImage
      v-if="visible"
      @closeImage="closeImage"
      :visible="visible"
      :amzSampleCode="formData.amzSampleCode"
      :title="$l('form_label_picture_maintenance') || '图片维护'"
    />
    <ChooseAmzSpu
      :visible.sync="chooseSpuVisible"
      :reserve="true"
      :amzSpuStatusList="['Y']"
      :multiple="false"
      :extraData="{
        collectionNoList: [this.formData.collectionNo],
        brandCodeList: [this.formData.brandCode],
      }"
      @confirm="spuConfirm"
    />

    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img
        v-for="item in listImageUrl"
        :src="item || '/image/static/img/nopic.jpg'"
        :key="item"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import SampleImage from './sample-image'
import { request } from '@/api/service'
import ChooseAmzSpu from './choose-amz-spu'
import dayjs from 'dayjs'
import SkuTable from '../sku-table'
export default {
  mixins: [EditLoading],
  components: { SampleImage, ChooseAmzSpu, SkuTable },
  props: {
    formDisabled: { type: Boolean, default: false },
    imageDisabled: { type: Boolean, default: false },
    amzSpuStatus: { type: String, default: '' },
    form: { type: Object, default: () => {} },
  },
  watch: {
    form: {
      handler(val) {
        if (val) {
          this.formData = { ...this.formData, ...val }
          const { amzSpuCode, colorCode } = this.formData
          if (amzSpuCode) {
            this.getColor(amzSpuCode)
            this.getPattern(amzSpuCode, colorCode)
            this.changeIsMany()
          }
        }
      },
      immediate: true,
    },
  },
  computed: {
    isEmpty() {
      return !this.formData.listImageUrl || !this.formData.listImageUrl.length
    },
    listImageUrl() {
      return this.isEmpty
        ? []
        : this.formData.listImageUrl.map((item) => item.displayImageUrl)
    },
    ...mapState('admin/user', ['info']),
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() >= Date.now() // 选当前时间之前的时间
        },
      },
      scmParams: {},
      colorOptions: [],
      goodsPatternOptions: [],
      formData: {
        defaultImageUrl: '',
        collectionNo: '',
        collectionName: '',
        goodsPattern: '',
        colorCode: '',
        sampleDate: dayjs().format('YYYY-MM-DD'),
        amzSpuCode: '',
        amzSpuNo: '',
        brandCode: '',
        amzSampleType: '',
      },
      visible: false,
      imageVisible: true,
      chooseSpuVisible: false,
      chooseSkuVisible: false,
      extraData: {},
      isMany: false,
      rules: {
        sampleDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',

            trigger: 'change',
          },
        ],
        scmCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',

            trigger: 'change',
          },
        ],
        amzSampleType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',

            trigger: 'change',
          },
        ],
        colorCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',

            trigger: 'change',
          },
        ],
        goodsPattern: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',

            trigger: 'change',
          },
        ],
        brandCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        collectionNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        colorPantone: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'change',
          },
        ],

        scmSampleNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        spuInfo: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {},
  methods: {
    ...mapActions('admin/page', ['close']),
    getColor(amzSpuCode) {
      request({
        url: '/ecom/amz/sample/dict/color',
        method: 'post',
        data: { amzSpuCode },
      }).then((res) => {
        this.colorOptions = res.body.data
      })
    },
    getPattern(amzSpuCode, colorCode) {
      request({
        url: '/ecom/amz/sample/dict/pattern',
        method: 'post',
        data: { amzSpuCode, colorCode },
      }).then((res) => {
        this.goodsPatternOptions = res.body.data
      })
    },
    openChooseSpu() {
      const { brandCode, collectionNo } = this.formData
      if (!brandCode || !collectionNo) {
        this.$message({
          message: '请先选择品牌、系列',
          type: 'warning',
        })
        return
      }
      this.chooseSpuVisible = true
    },
    async spuConfirm({ data }) {
      if (!data) return
      const { goodsName, goodsNameEn, amzSpuNo, amzSpuCode } = data
      this.formData.spuInfo = goodsName + ' / ' + goodsNameEn
      this.formData.amzSpuNo = amzSpuNo
      this.chooseSpuVisible = false
      this.getColor(amzSpuCode)
      if (this.formData.amzSpuCode != amzSpuCode) {
        this.clearColorPatter()
        this.clearSkuTable()
      }
      this.formData.amzSpuCode = amzSpuCode
    },
    changeIsMany() {
      const {
        amzSampleType,
        goodsPattern,
        colorCode,
        amzSpuCode,
        skuDataList,
      } = this.formData
      this.clearSkuTable()

      if (!amzSampleType) {
        this.isMany = false
        return
      }

      this.isMany =
        (amzSampleType
          ? amzSampleType.split('-')[1] == 'N'
            ? true
            : false
          : false) && !!goodsPattern
      this.extraData = {
        goodsPattern,
        colorCode,
        amzSpuCode,
      }

      if (skuDataList && skuDataList.length > 0) {
        this.$refs.skuTable.setTableData(skuDataList)
        this.formData.skuDataList = []
      } else {
        if (!this.isMany && !!goodsPattern) {
          this.$refs.skuTable.getData(this.extraData)
          return
        }
        if (this.isMany) {
          this.$refs.skuTable.openRadioVisible()
        }
      }
    },
    clearSpu() {
      if (this.formData.amzSpuCode) {
        this.formData.spuInfo = ''
        this.formData.amzSpuCode = ''
        this.formData.amzSpuNo = ''
        this.clearColorPatter()
      }
    },
    clearColorPatter() {
      this.formData.colorCode = ''
      this.colorOptions = []
      this.clearGoodsPattern()
    },
    clearGoodsPattern() {
      this.formData.goodsPattern = ''
      this.goodsPatternOptions = []
      this.clearSkuTable()
    },
    clearSkuTable() {
      this.$refs.skuTable.clearSkuTable()
    },

    async colorChange(colorCode) {
      this.formData.goodsPattern = ''
      this.goodsPatternOptions = []
      if (colorCode) {
        const res = await request({
          url: '/ecom/amz/sku/dict/color/detail',
          method: 'POST',
          data: { colorCode },
        }).catch(() => null)
        if (!res) return
        const { colorName, colorNameEn } = res.body
        this.formData.goodsColor = colorName
        this.formData.goodsColorEn = colorNameEn
        this.formData.goodsPattern = ''
        this.getPattern(this.formData.amzSpuCode, colorCode)
      }
      this.clearSkuTable()
    },
    onImagePreview() {
      if (this.isEmpty) return
      const viewer = this.$el.querySelector('.imagesViewer').$viewer

      const index = this.formData.listImageUrl.findIndex(
        (item) => item.displayImageUrl === this.formData.defaultImageUrl
      )
      viewer.view(index)
      viewer.show()
    },

    async validate() {
      const baseForm = await validate.formValidate([this.$refs.form])
      const skuResult = await this.$refs.skuTable.validate()
      return baseForm && skuResult
    },

    async save() {
      if (!(await this.validate())) return
      const details = await this.$refs.skuTable.getTableData()
      const codes = details.map((item) => {
        return item.amzSkuCode
      })
      this.loadingOpen()
      this.$api
        .ecomAmzSampleSaveApi({ ...this.formData, codes })
        .then(async (res) => {
          this.loadingClose()
          const { status, body } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.imageVisible = false

          const { amzSampleCode = '', amzSampleNo = '' } = body || {}
          if (amzSampleCode) {
            this.$router.replace({
              name: 'ecom-awsSample-sampleInfo-detail',
              params: { amzSampleCode, pageType: 'edit' },
              query: { amzSampleNo },
            })
            return
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    closeImage() {
      this.visible = false
      this.$api
        .ecomAmzSampleDetailApi({
          amzSampleCode: this.formData.amzSampleCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}

.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
}

.el-row {
  display: flex;
  align-items: stretch;
}
.image-col {
  padding: 0;
}
.colorCard {
  float: right;
  margin: 3px 0px 0px 5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 60px;
  color: #ffffff;
}
.text-col {
  padding: 0;
}
.text-wrapper {
  padding: 20px;
}
</style>
